<template>
  <div class="component">
    <div v-if="isSnecmaSafranUser">
      <p class="h4 heading branding">Thank you. Your request/inquiry has been successfully submitted.</p>
      <p><b>What will happen next?</b></p>
      <p>Your request will be routed to the Customer Support Centre for approval.</p>
      <p>
        Upon approval, if we see that your company has a designated local administrator, we will advise you who they are
        so you can contact them to request access. Otherwise, we will assign your request to the CFM Customer Support
        Manager responsible for setting up your account. Once access is granted, you will receive an email allowing you
        to set your password and connect to the myCFM Portal.
      </p>
      <p class="help-text">
        If you have any questions regarding the status of your request, please contact CFM Support via one of the
        following methods:
      </p>
      <cfm-fleet-support-team />
    </div>
    <div v-else>
      <p class="h4 heading branding">Thank you. Your request/inquiry has been successfully submitted.</p>
      <p><b>What will happen next?</b></p>
      <p>Your request has been routed to a CFM Sponsor for approval.</p>
      <p>
        Upon approval, the CFM Support Team will begin processing your request. Granting portal access typically takes
        1-5 business days from the date of the CFM Sponsor approval, depending on the complexity of the request. You
        will receive 2 e-mails during this time. The first will have your User ID, and the second will have your
        password. Please note that there can be up to 24 hours between the first and second e-mails.
      </p>
      <p>
        Once you receive your portal access, you can request access to specific widgets and applications using the My
        Access link available on the profile dropdown in the {{ portalName }} portal and you will be notified once the
        access has been granted.
      </p>
      <p class="help-text">
        If you have any questions regarding the status of your request, please
        <a :href = customerSupportURL target="_blank" class="underline">Contact Our Support Team</a>
      </p>
    </div>
    <div class="action-btns">
      <button type="submit" class="btn btn-sm btn-primary" @click="reloadPage">Close</button>
    </div>
  </div>
</template>
<script>
import cfmFleetSupportTeam from "./CfmFleetSupportTeam";

export default {
  components: {
    cfmFleetSupportTeam
  },
  props: {
    portalName: {
      type: String,
      required: true,
      default: "Access"
    }
  },
  data() {
    return {
      customerSupportURL: "https://www.cfmaeroengines.com/contact/"
    }
  },
  computed: {
    isSnecmaSafranUser() {
      return (
        this.$store.state.user.user.email.toLowerCase().endsWith("@safrangroup.com") ||
        this.$store.state.user.user.email.toLowerCase().endsWith("@snecma.com") ||
        this.$store.state.user.user.mdmOrgZone.toLowerCase().endsWith("sa")
      );
    }
  },
  created() {
    if (this.$store.state.user.user.mdmOrgZone == null) {
      this.$store.state.user.user.mdmOrgZone = "";
    }
  },
  methods: {
    reloadPage() {
      location.reload();
    }
  }
};
</script>

<style lang="less" scoped>
.component {
  padding-left: 20px;
  padding-right: 20px;
}

.branding {
  font-size: 23px;
  font-weight: bold;
  color: #004bbd;
  font-family: apexSans;
}
</style>
